import {Stack, Typography, useTheme} from '@mui/material';
import {AlertInfo} from 'presentation/components';
import {SubscriptionDialogs} from 'presentation/components/SubscriptionDialogs';
import {useHostName, usePersonalData} from 'presentation/hooks';
import Icon from 'presentation/icons';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {useElectronicBillSubscription} from 'presentation/pages/private/hooks/useElectronicBillSubscription';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {StyledLink, StyledSucessTyphography, StyledTypography} from './styles';
import {SubscriptionAlertProps} from './types';
import {BillsTaggingEnum} from 'main/analytics/gaTagsEnum';

const {digitalInvoiceAlert, digitalInvoiceInfo} =
	translations['pt-br'].privateFlow.myFinancial.openBills;

export const SubscriptionAlert = ({dataTagId, isBemobiFlow}: SubscriptionAlertProps) => {
	const {colors} = useTheme();
	const {isLaptop, isMobile} = useMediaQueries();
	const {isNotredameSaude} = useHostName();
	const useInvoiceCopy = !!isBemobiFlow || isNotredameSaude;
	const alertLine1 = useInvoiceCopy ? digitalInvoiceAlert.line1Bemobi : digitalInvoiceAlert.line1;
	const alertLine2 = useInvoiceCopy ? digitalInvoiceAlert.line2Bemobi : digitalInvoiceAlert.line2;
	const infoLine1 = useInvoiceCopy ? digitalInvoiceInfo.line1Bemobi : digitalInvoiceInfo.line1;
	const {
		protocol,
		handleSubscriptionResponse,
		handleCloseSubscriptionSucessModal,
		isSubscribed,
		handleToggleSubscriptionModal,
		handleToggleShowInfoModal,
		isSubmitting,
		setOperationState,
	} = useElectronicBillSubscription();
	const {currentEmail} = usePersonalData();

	let alertPadding = '16px 16px 8px';
	if (isBemobiFlow) alertPadding = '6px 16px 8px';
	else if (!isMobile && !isBemobiFlow) alertPadding = '16px 32px';

	return (
		<Fragment>
			{isSubscribed ? (
				<AlertInfo.Root
					severity="success"
					icon={<Icon name="check-circle-filled" color={colors.light.success.dark} />}
					sx={{
						backgroundColor: colors.brand.primary.white,
						padding: isLaptop ? '16px 16px 8px' : '16px 32px',
					}}>
					<AlertInfo.Description>
						<StyledSucessTyphography variant="body2" color={colors.light.text.primary}>
							{infoLine1}
							<StyledLink
								data-tag-id={BillsTaggingEnum.CLICK_SAIBA_MAIS_ADESAO_BOLETO}
								variant="label"
								onClick={() => handleToggleShowInfoModal(true)}>
								{digitalInvoiceInfo.primaryAction}
							</StyledLink>
						</StyledSucessTyphography>
					</AlertInfo.Description>
				</AlertInfo.Root>
			) : (
				<AlertInfo.Root
					severity="info"
					icon={<Icon name="receipt-long-filled" />}
					sx={{
						padding: alertPadding,
					}}>
					<AlertInfo.Description>
						<Stack
							justifyContent={'space-between'}
							flexDirection={isLaptop ? 'column' : 'row'}>
							<Typography
								variant="body1"
								color={colors.light.text.primary}
								sx={isBemobiFlow ? {fontSize: '14px'} : undefined}>
								{alertLine1}
								<b
									style={isBemobiFlow ? {fontWeight: 600} : undefined}
									color={colors.light.primary.main}>
									{alertLine2}
								</b>
							</Typography>
							<StyledTypography
								data-tag-id={dataTagId}
								isLaptop={!!isLaptop}
								isBemobiFlow={isBemobiFlow}
								variant="body1"
								onClick={() => handleToggleSubscriptionModal(true)}>
								{digitalInvoiceAlert.primaryAction}
							</StyledTypography>
						</Stack>
					</AlertInfo.Description>
				</AlertInfo.Root>
			)}
			<SubscriptionDialogs
				isBemobiFlow={useInvoiceCopy}
				dataTagId={{
					closeButton:
						BillsTaggingEnum.CLICK_FECHAR_MODAL_CONCLUSAO_ADESAO_BOLETO_DIGITAL,
					header: BillsTaggingEnum.VISUALIZOU_MODAL_CONCLUSAO_ADESAO_BOLETO_DIGITAL,
					understandButton:
						BillsTaggingEnum.CLICK_ENTENDI_MODAL_CONCLUSAO_ADESAO_BOLETO_DIGITAL,
				}}
				isSubmitting={isSubmitting}
				onSubscriptionResponse={handleSubscriptionResponse}
				onCloseSubscriptionModal={() => handleToggleSubscriptionModal(false)}
				onCloseSubscriptionSucessModal={handleCloseSubscriptionSucessModal}
				onShowSubscriptionModal={() => handleToggleSubscriptionModal(true)}
				onCloseInfoModal={() => handleToggleShowInfoModal(false)}
				onShowInfoModal={() => handleToggleShowInfoModal(true)}
				currentEmail={currentEmail}
				protocol={protocol}
				setOperationState={setOperationState}
			/>
		</Fragment>
	);
};
